import { Actions } from './contact-types.actions'
import { fromJS } from 'immutable'
import * as ContactTypesTypes from './contact-types.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    total: 0,
    results: 0,
  },
  createContactType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateContactType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function contactTypesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ContactTypesTypes.UPDATE_CONTACT_TYPE_REQUEST: {
      return state.setIn(['updateContactType', 'isLoading'], true)
    }

    case ContactTypesTypes.UPDATE_CONTACT_TYPE_SUCCESS: {
      return state.setIn(['updateContactType', 'isLoading'], false)
    }

    case ContactTypesTypes.UPDATE_CONTACT_TYPE_FAILURE: {
      return state.setIn(['updateContactType', 'isLoading'], false)
    }

    case ContactTypesTypes.CREATE_CONTACT_TYPE_REQUEST: {
      return state.setIn(['createContactType', 'isLoading'], true)
    }

    case ContactTypesTypes.CREATE_CONTACT_TYPE_SUCCESS: {
      return state.setIn(['createContactType', 'isLoading'], false)
    }

    case ContactTypesTypes.CREATE_CONTACT_TYPE_FAILURE: {
      return state.setIn(['createContactType', 'isLoading'], false)
    }

    case ContactTypesTypes.DELETE_CONTACT_TYPE_REQUEST: {
      return state
    }

    case ContactTypesTypes.DELETE_CONTACT_TYPE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case ContactTypesTypes.DELETE_CONTACT_TYPE_FAILURE: {
      return state
    }

    case ContactTypesTypes.FETCH_CONTACT_TYPES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case ContactTypesTypes.FETCH_CONTACT_TYPES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case ContactTypesTypes.FETCH_CONTACT_TYPES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case ContactTypesTypes.FETCH_CONTACT_TYPE_REQUEST: {
      return state.setIn(['updateContactType', 'isLoading'], true)
    }

    case ContactTypesTypes.FETCH_CONTACT_TYPE_SUCCESS: {
      return state
        .setIn(['updateContactType', 'isLoading'], false)
        .setIn(
          ['updateContactType', 'data'],
          fromJS(action.payload).delete('contactType').delete('id'),
        )
    }

    case ContactTypesTypes.FETCH_CONTACT_TYPE_FAILURE: {
      return state.setIn(['updateContactType', 'isLoading'], false)
    }

    case ContactTypesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case ContactTypesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
